export default {
  venture: (state) => state.venture,
};
